import React, { useState } from 'react';
import { Box, Button, Text, Radio, RadioGroup, Stack } from '@chakra-ui/react';

const questions = [
  {
    question: "Who is known as the 'Cosmic Entity'?",
    options: ['Cthulhu', 'Azathoth', 'Nyarlathotep', 'Dagon'],
    answer: 'Azathoth',
  },
  {
    question: "Which book is considered Lovecraft's most famous creation?",
    options: ['The Call of Cthulhu', 'At the Mountains of Madness', 'The Shadow over Innsmouth', 'The Necronomicon'],
    answer: 'The Necronomicon',
  },
  // More questions can be added here
];

const ForbiddenKnowledgeQuiz = () => {
  const [currentQuestion, setCurrentQuestion] = useState(0);
  const [selectedOption, setSelectedOption] = useState('');
  const [showResult, setShowResult] = useState(false);
  const [score, setScore] = useState(0);

  console.log('Current Question:', currentQuestion);
  console.log('Selected Option:', selectedOption);
  console.log('Show Result:', showResult);
  console.log('Score:', score);
  console.log('Questions:', questions);

  const handleOptionChange = (value) => {
    setSelectedOption(value);
    console.log('Option selected:', value);
  };

  const handleSubmit = () => {
    if (selectedOption === questions[currentQuestion].answer) {
      setScore(score + 1);
      console.log('Correct answer, new score:', score + 1);
    } else {
      console.log('Incorrect answer, score remains:', score);
    }

    if (currentQuestion < questions.length - 1) {
      setCurrentQuestion(currentQuestion + 1);
      setSelectedOption('');
      console.log('Next question:', currentQuestion + 1);
    } else {
      setShowResult(true);
      console.log('Quiz completed, final score:', score);
    }
  };

  return (
    <Box p={5} shadow="md" borderWidth="1px">
      {!showResult ? (
        <>
          <Text mb={4}>{questions[currentQuestion].question}</Text>
          <RadioGroup onChange={handleOptionChange} value={selectedOption}>
            <Stack direction="column">
              {questions[currentQuestion].options.map((option, index) => (
                <Radio key={index} value={option}>
                  {option}
                </Radio>
              ))}
            </Stack>
          </RadioGroup>
          <Button mt={4} colorScheme="teal" onClick={handleSubmit}>
            Submit
          </Button>
        </>
      ) : (
        <Text mt={4}>
          Your score: {score}/{questions.length}
        </Text>
      )}
    </Box>
  );
};

export default ForbiddenKnowledgeQuiz;
